"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const {
    ref: leftColRef,
    isVisible: leftColVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightColRef,
    isVisible: rightColVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrollY = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrollY * 0.4}px)`;
      }
    };
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!prefersReducedMotion) {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section className="relative min-h-screen w-full overflow-hidden bg-dark-background">
      {}
      <div ref={parallaxRef} className="absolute inset-0 h-[120vh] w-full bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/hero_fire_protection_background.png)"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-dark-background/60" aria-hidden="true" />

      {}
      <div className="relative z-10 flex min-h-screen items-center px-6 py-16 sm:px-8 md:px-12 lg:px-16">
        <div className="mx-auto grid w-full max-w-7xl gap-12 md:grid-cols-2 md:gap-16">
          {}
          <div ref={leftColRef} className={`flex flex-col justify-center space-y-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${leftColVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <img src="https://apfire.10web.cloud/wp-content/uploads/2025/12/cropped-cropped-ChatGPT-Image-Dec-9-2025-at-06_47_54-PM-1.png" alt="A+ Fire Logo" className="w-20 h-20 mb-8" />
            <div className="space-y-4">
              <h1 className="font-display text-4xl font-bold leading-tight text-foreground-dark sm:text-5xl md:text-6xl lg:text-7xl">Call Mike,
Not Some Secretary<br /><span className="mt-2 block h-1 w-24 rounded-full bg-primary" aria-hidden="true" /></h1>
              <p className="font-display text-xl font-semibold text-primary sm:text-2xl md:text-3xl">
                Don't get burned by the other guys.
              </p>
            </div>
          </div>

          {}
          <div ref={rightColRef} className={`flex flex-col justify-center space-y-5 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${rightColVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <Link to="/ContactPage">
              <Button size="lg" className="w-full bg-primary text-foreground-primary font-semibold text-base shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:bg-primary-hover hover:shadow-strong focus-visible:ring-2 focus-visible:ring-ring sm:text-lg md:w-auto md:min-w-[280px]">
                Call Mike Directly
              </Button>
            </Link>
            <Link to="/ContactPage">
              <Button size="lg" className="w-full bg-primary text-foreground-primary font-semibold text-base shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:bg-primary-hover hover:shadow-strong focus-visible:ring-2 focus-visible:ring-ring sm:text-lg md:w-auto md:min-w-[280px]">
                Request Service
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}